import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from '../../../../../utils/useTranslation';
import { IconRubInCircle } from '../../../../icon/IconRubInCircle';
import { IconRubInCircleFilled } from '../../../../icon/IconRubInCircleFilled';
import { Typography } from '../../../../typography/Typography';
import { ADVERTISING_CATALOG_URL, CATALOG_URLS } from './constants';
import { Button } from './styles';
import { AdvertisingButtonProps } from './types';

export const AdvertisingButton: React.FC<AdvertisingButtonProps> = ({
    target,
    text,
    textProps,
    onClick,
    ...other
}) => {
    const t = useTranslation();
    const { pathname } = useLocation();
    const isActive = CATALOG_URLS.includes(pathname);

    return (
        <Button
            as={NavLink}
            target={target}
            to={ADVERTISING_CATALOG_URL}
            onClick={onClick}
            {...other}
        >
            {isActive ? <IconRubInCircleFilled size={24} /> : <IconRubInCircle size={24} />}
            <Typography
                {...textProps}
                variant="body"
                weight="bold"
                textTransform="none"
                color="inherit"
            >
                {text ?? t('Монетизация')}
            </Typography>
        </Button>
    );
};
